<div class="sections">
  <div class="card header-card">
    <div class="card-header display-flex billing-header">
      <div class="flex-start gap-3">
        <h5 class="mb-0">Azure Advisor</h5>
      </div>
      <div class="flex-gap billing-actions">
        <div class="last-refresh">
          <span class="font-bold">Last Refreshed:</span>
          <span>{{ lastRefreshedLabel }}</span>
        </div>
        <button
          class="btn btn-primary-soft"
          (click)="onScan()"
          [disabled]="!scanEnabled"
          title="Scan is currently disabled"
        >
          Scan
        </button>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-body flow-auto">
      <div class="alert alert-danger" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <table class="table table-docs table-hover">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Subscription ID</th>
            <th>Score</th>
          </tr>
        </thead>
        <tbody *ngIf="rows.length > 0">
          <tr *ngFor="let row of rows; let i = index">
            <td>{{ i + 1 }}</td>
            <td>
              <span class="nav-link p-0" (click)="openPillarScores(row)">
                {{ row.subscription_id || "-" }}
              </span>
            </td>
            <td>{{ row.score || "-" }}</td>
          </tr>
        </tbody>
        <tbody *ngIf="!loading && rows.length === 0">
          <tr>
            <td colspan="3" class="center">No data found</td>
          </tr>
        </tbody>
        <tbody *ngIf="loading">
          <tr>
            <td colspan="3" class="center">
              <div class="loader-wrap">
                <img src="assets/img/loading_2.svg" alt="loading scans" class="width-18" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
